import { useState, useEffect } from 'react';

const LOGO_URL =
  'https://static.readdy.ai/image/50d82ed5e67db213de3cd7b55d8920db/7c6a3ed7e0c4b6c2e2894c907f853820.png';

const NAV_ITEMS = [
  { label: '会社概要', anchor: 'company-info' },
  { label: 'サービス', anchor: 'services' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (anchor: string) => {
    setMenuOpen(false);
    const el = document.getElementById(anchor);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/95 backdrop-blur-sm border-b border-[#C8E4F2]' : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between px-10 max-w-none" style={{ paddingTop: scrolled ? '14px' : '20px', paddingBottom: scrolled ? '14px' : '20px' }}>
        <button
          onClick={() => scrollTo('hero')}
          className="flex items-center gap-4 cursor-pointer"
        >
          <div className={`flex items-center justify-center transition-all duration-500 ${scrolled ? 'w-14 h-14' : 'w-28 h-28'}`}>
            <img src={LOGO_URL} alt="湘南ビジネスサポート" className="w-full h-full object-contain drop-shadow-lg" />
          </div>
          <div className="flex flex-col leading-tight">
            <span
              className={`tracking-[0.2em] transition-all duration-500 font-light ${
                scrolled ? 'text-xs text-[#2B8DB8]' : 'text-sm text-[#7EC8E8]'
              }`}
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              SHONAN BUSINESS SUPPORT
            </span>
            <span
              className={`font-semibold tracking-widest transition-all duration-500 ${
                scrolled ? 'text-sm text-[#1A2E3A]' : 'text-base text-white'
              }`}
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              株式会社湘南ビジネスサポート
            </span>
          </div>
        </button>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-10">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.anchor}
              onClick={() => scrollTo(item.anchor)}
              className={`text-sm tracking-widest transition-all duration-300 relative group cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-[#1A2E3A]' : 'text-white/90'
              }`}
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              {item.label}
              <span className="absolute -bottom-1 left-0 h-px bg-[#2B8DB8] w-0 group-hover:w-full transition-all duration-300" />
            </button>
          ))}
          <button
            onClick={() => scrollTo('contact')}
            className="px-6 py-2.5 bg-[#2B8DB8] text-white text-xs tracking-widest rounded-full hover:bg-[#1E6E94] transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            お問い合わせ
          </button>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="lg:hidden w-8 h-8 flex flex-col justify-center items-center gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <span className={`block w-6 h-px transition-all duration-300 ${scrolled ? 'bg-[#1A2E3A]' : 'bg-white'} ${menuOpen ? 'rotate-45 translate-y-1.5' : ''}`} />
          <span className={`block w-6 h-px transition-all duration-300 ${scrolled ? 'bg-[#1A2E3A]' : 'bg-white'} ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-6 h-px transition-all duration-300 ${scrolled ? 'bg-[#1A2E3A]' : 'bg-white'} ${menuOpen ? '-rotate-45 -translate-y-3' : ''}`} />
        </button>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 ${
          menuOpen ? 'max-h-80 bg-white/98 border-b border-[#C8E4F2]' : 'max-h-0'
        }`}
      >
        <div className="px-10 py-6 flex flex-col gap-6">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.anchor}
              onClick={() => scrollTo(item.anchor)}
              className="text-sm text-[#1A2E3A] tracking-widest cursor-pointer text-left"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('contact')}
            className="px-6 py-2.5 bg-[#2B8DB8] text-white text-xs tracking-widest rounded-full text-center cursor-pointer whitespace-nowrap w-fit"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            お問い合わせ
          </button>
        </div>
      </div>
    </header>
  );
}
